import * as React from "react";

const IconPlus: React.FC = () => {
    return <svg xmlns="http://www.w3.org/2000/svg" width="11" height="11" viewBox="0 0 11 11" fill="currentColor"><polygon points="5.438 .563 5.438 0 4.313 0 4.313 .563 4.313 4.313 .563 4.313 0 4.313 0 5.438 .563 5.438 4.313 5.438 4.313 9.188 4.313 9.75 5.438 9.75 5.438 9.188 5.438 5.438 9.188 5.438 9.75 5.438 9.75 4.313 9.188 4.313 5.438 4.313"  transform="translate(.625 .625)"/></svg>;
};

export default React.memo(IconPlus);
